<template>
  <div>
    <p>All your changes will be lost.</p>
    <br />

    <p>
      {{
        isDraftEvent
          ? "Are you sure you want to delete your event?"
          : "Are you sure you want to discard the unsaved changes?"
      }}
    </p>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  props: {
    isDraftEvent: {
      type: Boolean,
      required: true,
    },
  },
});
</script>
